import { Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';


import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

var $ = require('jquery');
require('jquery-ui-bundle');

import { ActivatedRoute }    from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { TweenMax, TimelineMax } from "gsap";
//import * as $ from 'jquery/dist/jquery.min.js';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { BrowserModule, Title }  from '@angular/platform-browser';

declare var elements;
declare var stripe;

@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'renew',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./renew.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./renew.component.html')
})


export class RenewComponent implements OnInit {
  hasChanges :boolean = true;
  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if(this.hasChanges) $event.returnValue='Your data will be lost!';
  }


  /**
   * Set our default values
   */
  public localState = { value: '' };
  public myForm: FormGroup; // our model driven form
  public submitted: boolean; // keep track on whether form is submitted
  membership: any;
  fees:any;
  is_loading:boolean = false;
  
  pay_now_btn: any = "Please Select Membership";
  @ViewChild('cardInfo') cardInfo: ElementRef;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;

  /**
   * TypeScript public modifiers
   */
  // constructor(
  //   public appState: AppState,
  //   public title: Title,
  //   private _fb : FormBuilder
  // ) {}

  constructor(
    public appState: AppState,
    public title: Title,
    private _fb : FormBuilder,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {}




  public ngOnInit() {
    // console.log('hello `renew` component');
    this.title.setTitle("The Tiger Club | Renew Your Membership");
    this.fees = this.appState.getFees();
    this.memberships = [
      {
          id: 1,
          title: "Full Flying Membership",
          short: "full",
          price: this.fees.membership.full
        },
        {
          id: 2,
          title: "Youth Membership (under 24)",
          short: "youth",
          price: this.fees.membership.youth
        },
        {
          id: 3,
          title: "Overseas Membership",
          short: "overseas",
          price: this.fees.membership.overseas
        },
        {
          id: 4,
          title: "Associate Membership",
          short: "asso",
          price: this.fees.membership.associate
        }
  ];


    this.myForm = this._fb.group({
            membership: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]],
            licence: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            licence_number: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            sep_expiry: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            medical_expiry: ['', [<any>Validators.required, <any>Validators.minLength(6)]],
            total_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            p1_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            other_ratings: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            tnc: ['', [<any>Validators.required, <any>Validators.required]],
            types_flown: ['', [<any>Validators.required, <any>Validators.minLength(3)]]
        });

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
     // $("#main_header").addClass("after_scroll");


    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);


     
  }

  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
      this.check_pay();
    }
    this.cd.detectChanges();
  }

  check_pay(){

    //validating the form before we go further
    if(this.selected_membership.length > 0){

      this.update_membership();
      
      // this.pay_now_btn = "Pay £"+this.pay_now;
      // this.disable_pay_button = false;
    }

    


  }

  memberships:any;
  selected_membership: any;

  update_membership(){

      // console.log("UPDATE CALLED");
       var ids = this.membership;
      // console.log("id: ",ids);
       var found = this.memberships.find(function(el) {
         return el.id == ids;
       });
      // console.log("id: ",found);
      this.selected_membership = found;
      this.membership = found.id;
      // console.log("FOUND", found);
      //this.membership = found;

    var val = this.selected_membership.short;

    if(val == "asso"){
      this.myForm = this._fb.group({
            membership: [val, [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]],
            tnc: ['', [<any>Validators.required, <any>Validators.required]]
        });
    } else {
      this.myForm = this._fb.group({
            membership: [val, [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            licence: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            licence_number: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            sep_expiry: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical_expiry: ['', [<any>Validators.required, <any>Validators.minLength(6)]],
            total_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            p1_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            other_ratings: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            types_flown: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            tnc: ['', [<any>Validators.required, <any>Validators.required]]
        });
    }


      this.appState.get_super_secret_token({cost: this.selected_membership.price, experience: this.selected_membership.title, receipt: this.myForm.controls.email.value}).subscribe((data: any) => {
             var data = JSON.parse(data._body);
             //console.log("super_secret_token ::: ", data);
            this.super_secret_token = data.intent.client_secret;
          })



      this.pay_now_btn = "Renew Membership £"+this.selected_membership.price;
  }
  
  super_secret_token:any = "";

  updated_select(){
  
    // console.log("UPDATED", val);
    //var ids = this.membership;
    //this.membership = val;
  
  }

  disable_pay_button:boolean = false;
  purchased_membership: any;
  success_membership: any = {
    first_name: "",
    last_name: "",
    email: "",
    membership: "",
    price: ""
  };

  save(data, valid){
    // console.log("valid", valid);
     //console.log("data", data);
    if(valid){

      this.is_loading = true;
      //then take the charge...
      this.disable_pay_button = true;


      var cardholderName = document.getElementById('cardholder-name');
      var cardButton = document.getElementById('card-button');
      var clientSecret = cardButton.dataset.secret;

      var _this = this;

        stripe.handleCardPayment(
          clientSecret, this.card, {
            payment_method_data: {
              billing_details: {name: data.first_name+" "+data.last_name}
            },
            receipt_email: data.email
          }
        ).then(function(result) {
          if (result.error) {
            // Display error.message in your UI.
            // console.log('Something is wrong:', result.error);
            alert(result.error.message);
            _this.disable_pay_button = false;
            _this.is_loading = false;

            return false;

          } else {
              // The payment has succeeded. Display a success message.
              // console.log("RESULTS", result);
              // console.log("selected", _this.selected_membership);

              data.membership = _this.selected_membership.title;
              data.token_id = result.paymentIntent.id;
              data.cost = result.paymentIntent.amount / 100;

              // console.log("BEFORE SEND NOW ==> ", data);

              //generate_the_voucher
              _this.appState.buy_membership(data).subscribe((content: any) => {
                  
                //buy_membership
                // console.log("BUY RESPONSE ", content);
                //return false;

                var response = JSON.parse(content._body);
                // console.log("BUY RESPONSE2 ", response);
                _this.purchased_membership = response.membership;

                if(response.success){

                    data.name = data.first_name+" "+data.last_name;
                    data.title = "Membership Renewal";
                    data.membership_type = _this.selected_membership.title;
                    data.membership = _this.selected_membership.title;
                    //data.voucher_code = _this.purchased_membership.voucher_code;

                     _this.success_membership = data;

                    // console.log("EMAILS NOW ==> ", data);
                    // console.log("SPECIFICALLY ==> EXPERIENCE: ", data.experience);


              //SEND THE EMAIL TO USER --> THANK YOU FOR RENEWAL
              var user_body = {
                  From: "info@tigerclub.co.uk",
                  To: data.email,
                  //TemplateId: 11608568,
                  TemplateId: 14697226,
                  TemplateModel: data
                };
               // console.log("USER SENT HERE ", user_body);

              _this.appState.send_email(user_body, 2).subscribe((data: any) => {
                  // console.log("USER SENT HERE ", data);
                });






              //check the emails are being sent properly









              //SEND THE EMAIL TO STAFF
              var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "info@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body, 2).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })

                //_this.show_thank_you = true;

                $("#the_form").fadeOut();
                $("#thank_you").fadeIn();
                _this.disable_pay_button = false;


              } else {
                // this.bought_voucher.voucher_code = "";
                data.message = response.message;
                data.name = data.first_name+" "+data.last_name;
                data.title = "Membership ERROR";

                var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "social@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })
                //an error occurred..... 
                alert("An error has ocurred, "+response.message);
                _this.disable_pay_button = false;
                _this.is_loading = false;
                return false;

              }

              },
              (err) => {
                // this.bought_voucher.voucher_code = "";
                // console.log(err);

                data.message = err.message;
                data.name = data.first_name+" "+data.last_name;
                data.title = "Membership ERROR";

                var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "social@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })

                alert("An error has ocurred, "+err.message);
                _this.disable_pay_button = false;
                _this.is_loading = false;

                return false;
              });



          }
        });




































      // console.log("SAVED?");





      // $("#the_form").fadeOut();
      // $("#thank_you").fadeIn();

      // var membership_name = "";

      // switch (data.membership) {
      //   case "full":
      //     membership_name = "Full Flying Membership - £"+this.fees.membership.full+" per year";

      //   break;

      //   case "temp":
           
      //     membership_name = "Temporary Flying Membership - £"+this.fees.membership.temp+" per month";


      //   break;

      //   case "overseas":
           
      //     membership_name = "Overseas Flying Membership - £"+this.fees.membership.overseas+" per year";


      //   break;

      //   case "asso":
           
      //     membership_name = "Associate Membership - £"+this.fees.membership.associate+" per year";

      //   break;       
      // }

      // data.name = data.first_name+" "+data.last_name;
      // data.title = "Membership Request";
      // data.membership_name = membership_name;
      // //requires a little more stuff for this one / new template
      // //SEND THE EMAIL TO USER --> THANK YOU FOR CONTACT
      // var user_body = {
      //     From: "info@tigerclub.co.uk",
      //     To: data.email,
      //     TemplateId: 5536623,
      //     TemplateModel: data
      //   };
      //  // console.log("USER SENT HERE ", user_body);

      // this.appState.send_email(user_body, true).subscribe((data: any) => {
      //     // console.log("USER SENT HERE ", data);
      //   })


      // //SEND THE EMAIL TO STAFF
      // var staff_body = {
      //     From: "info@tigerclub.co.uk",
      //     To: "info@tigerclub.co.uk",
      //     TemplateId: 5523702,
      //     TemplateModel: data
      //   };


      //   // console.log("STAFF SENT HERE ", staff_body);
      //   this.appState.send_email(staff_body, true).subscribe((data: any) => {
      //     // console.log("STAFF SENT HERE ", data);
      //   })





    } else {
       // console.log("FAILED? ", valid);
       // console.log("FAILED? ", data);
      alert("Please complete all fields in the form.");
    }
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/renew/renew.component.ts